<template>
  <v-col
    :class="{
      'get-lower': !$vuetify.breakpoint.mdAndUp,
      'pa-0': true,
      fullScreen: true,
      fullScreenMobile: this.$vuetify.breakpoint.mdAndDown
    }"
    cols="12"
  >
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("tariff-plans.tariff-plans") }}</v-toolbar-title>
      <v-toolbar-items>
        <v-btn text color="primary" :to="{ name: 'new-tariff-plan' }">
          <v-icon left>mdi-plus</v-icon>
          {{ $t("tariff-plans.create") }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col>
      <Search></Search>
    </v-col>
    <CommonTable
      list-getter="projectMeteringStore/tariffPlanStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="tariff-plans"
      createItemDispatch="projectMeteringStore/tariffPlanStore/create"
      deleteItemDispatch="projectMeteringStore/tariffPlanStore/delete"
      @updated="updateList"
      :loading.sync="loading"
      :selected.sync="selected"
      :static-dispatch-params="{ project_id: this.project_id }"
      show-select
    ></CommonTable>
    <Paginator
      page-getter="projectMeteringStore/tariffPlanStore/getPage"
    ></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../../../components/common/tables/Paginator";
import Search from "../../../components/common/tables/Search";
import CommonTable from "../../../components/common/tables/CommonTable";
import { rules } from "../../../components/mixins/rules";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
import { projectPermissions } from "../../../components/mixins/projects/projectPermissions";

export default {
  name: "TariffPlans",
  props: ["project_id"],
  mixins: [rules, projectTitle, projectPermissions],
  components: { Paginator, CommonTable, Search },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("tariff-plans.name"),
          align: "left",
          value: "name"
        }
      ],
      actions: [],
      slots: [
        {
          name: "name",
          type: "link",
          to: "tariff-plan"
        }
      ],
      loading: false,
      selected: []
    };
  },
  computed: {
    getParams() {
      return ` ${this.$route.query.page}
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                `;
    }
  },
  watch: {
    getParams: function() {
      this.updateList();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("tariff-plans.tariff-plans")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectMeteringStore/tariffPlanStore/getList", {
        params,
        onSuccess: () => {
          this.loading = false;
        }
      });
    },
    formingParams() {
      return {
        project_id: this.$props.project_id,
        page: this.$route.query.page,
        limit: this.$route.query.limit_items,
        orders: this.$route.query.orders,
        filters: {
          name: this.$route.query.search
        }
      };
    }
  },
  mounted() {
    this.updateList();
  }
};
</script>

<style scoped>
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
</style>
